var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text text-secondary-text",class:this.parent},[_c('the-text-view',{attrs:{"value":_vm.articleItem.news_text}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }